import React, { ReactNode } from "react";

import { Link, MenuItem } from "@chakra-ui/react";

const hoverStyle = { backgroundColor: "#EDF5F3" };

export const CustomMenuItem = ({
  href = undefined,
  onClick = undefined,
  isExternal = false,
  children,
}: {
  href?: string;
  onClick?: () => void;
  isExternal?: boolean;
  children: ReactNode;
}) => (
  <MenuItem
    fontSize="sm"
    px={5}
    h={10}
    as={Link}
    href={href}
    onClick={onClick}
    _hover={hoverStyle}
    isExternal={isExternal}
  >
    {children}
  </MenuItem>
);
